"use client";

import Head from "next/head";
import HeroSection from "./components/HeroSection";
import LikeStudy from "./components/LikeStudy";
import TopCounselingListSection from "./components/TopCounselingListSection";
import AddmissionProcess from "./components/AddmissionProcess";
import MbbsExclusivePartners from "./components/MbbsExclusivePartners";
import FaqSection from "./components/FaqSection";
import DocumentsReady from "./components/DocumentsReady";

export default function MBBSAbroadPage() {
  const keywords = [
    "Study MBBS Abroad",
    "MBBS Abroad for Indian Students",
    "MBBS Abroad 2026",
    "NEET eligibility for MBBS Abroad",
    "FMGE / NExT tips",
    "Top MBBS Abroad Countries",
    "MBBS Tuition Fees Abroad",
    "Admission Process MBBS Abroad",
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Study MBBS Abroad 2026 | NEET Support",
    "url": "https://neetsupport.com/mbbs-abroad",
    "description": "Explore MBBS abroad guidance — NEET eligibility, admission steps, top countries, FMGE/NExT tips, and tuition cost with NEET Support.",
    "keywords": keywords.join(", "),
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://neetsupport.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "MBBS Abroad",
          "item": "https://neetsupport.com/mbbs-abroad"
        }
      ]
    },
    "mainEntity": [
      {
        "@type": "FAQPage",
        "name": "MBBS Abroad FAQs",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Which countries are best for MBBS abroad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Top countries include Russia, Georgia, Ukraine, Bangladesh, Nepal, and the Philippines."
            }
          },
          {
            "@type": "Question",
            "name": "Is NEET required for MBBS abroad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Indian students must qualify NEET to pursue MBBS abroad."
            }
          },
          {
            "@type": "Question",
            "name": "What is the cost of MBBS abroad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The total cost varies by country and university, typically ranging from ₹20–60 lakh including tuition, hostel, and living expenses."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <Head>
        <title>
          Study MBBS Abroad 2026 for Indian Students — Costs & NEET Eligibility | NEET Support
        </title>
        <meta
          name="description"
          content="Explore comprehensive MBBS abroad guidance — costs in top countries, NEET eligibility, FMGE/NExT advice, admission steps, and expert counseling from NEET Support."
        />
        <meta name="keywords" content={keywords.join(", ")} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://neetsupport.com/mbbs-abroad" />
        <meta property="og:title" content="Study MBBS Abroad 2026 for Indian Students | NEET Support" />
        <meta
          property="og:description"
          content="Get expert guidance on MBBS abroad — NEET eligibility, country selection, admission process, FMGE/NExT tips, and cost comparison."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://neetsupport.com/mbbs-abroad" />
        <meta property="og:image" content="/assets/img/mbbs-abroad-og.jpg" />

        {/* JSON-LD structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>

      <main className="min-h-screen bg-[#fff8f2] text-slate-900">
        <HeroSection />
        <LikeStudy />
        <TopCounselingListSection />
        <AddmissionProcess />
        <MbbsExclusivePartners />
        <DocumentsReady/>
        <FaqSection />
      </main>
    </>
  );
}